import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CartService } from '@app/services/cart.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { AuthenticationService } from '@app/services/authentication.service';
import { NotificationService } from '@app/services/notification.service';
import { WhatsAppService } from '@app/services/whatsapp.service';
import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';

@Component({
    selector: 'app-mobile-header',
    imports: [CommonModule, RouterModule, FormsModule, GalaxyButtonDirective, GalaxyRippleDirective],
    templateUrl: './mobile-header.component.html',
    styleUrl: './mobile-header.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileHeaderComponent {
  isSearchVisible = false;
  searchQuery: string = '';

  vm$: Observable<{ isLoggedIn: boolean; cartQuantity: number; }>;

  constructor(
    private cartService: CartService, 
    private router: Router,
    private authService: AuthenticationService,
    private notificationService: NotificationService,
    private whatsappService: WhatsAppService
  ) {
    this.vm$ = combineLatest([
      this.authService.isLoggedIn$,
      this.cartService.quantity$
    ]).pipe(
      map(([isLoggedIn, cartQuantity]) => ({ isLoggedIn, cartQuantity }))
    );
  }

  toggleSearch(): void {
    this.isSearchVisible = !this.isSearchVisible;
  }

  openSupportChat(): void {
    this.whatsappService.openGeneralSupportChat();
  }

  onSearch(): void {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/tienda'], { queryParams: { search: this.searchQuery } });
      this.isSearchVisible = false;
      this.searchQuery = '';
    }
  }

  async logout(): Promise<void> {
    const result = await this.notificationService.confirm('¿Cerrar sesión?', '¿Estás seguro de que quieres cerrar tu sesión?', 'question');
    if (result.isConfirmed) {
      this.authService.logout();
    }
  }
}
